import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute() {
  const token = localStorage.getItem("token");
  // token bo'lmasa => Home sahifasiga qaytar
  return token ? <Outlet /> : <Navigate to="/" replace />;
}
